/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ProviderExaminationFullApiModel { 
    providerExaminationId: number;
    requireSample: boolean;
    medicalExaminationTypeId: number;
    medicalExaminationTypeName: string;
    price: number;
}

